// removed by extract-text-webpack-plugin
module.exports = {"component":"_35CcREZ3GzmdpUtmOeStdq","gerul":"_39N-vsIt9qBar0BWcrGeuk","gerLink":"_3zxiGI8Bc0_dhudgq4PPyh","border":"K1So6keAGZnX8Wso9x3wG","jsdd":"_2VgTRie23fgUUiCSttnNcE","selt":"_-3Xy7nevzKlsYT9qhfDX3","jsallshou":"_2Q2ZzuTjUaBuRd8MwtI1w","img":"_10bxRqoUWQeQnJvCVmtkDJ","allTable":"_1KGQFJRElN9f_duRoYz4ea","bttn":"_3TgQHPGYR4NuiO20NlCkZp"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MyClients/MyClients.scss
 ** module id = 1072
 ** module chunks = 0
 **/